/* Newsletter invitation
   The first pageview is always clear. On later pageviews the card can appear
   after 30 seconds plus a footer visit, or after 90 seconds of active reading.
   Privacy choices take priority and are followed by a 30-second quiet interval.
   Dismissal and completed signup are respected in localStorage.
   Success truth is server-rendered when Shopify's customer_posted flag comes
   back as a query param, and recovered here when the redirect leaves it
   inside the #letters fragment where Liquid cannot see it. */
(function () {
  'use strict';

  var card = document.querySelector('[data-nl]');
  if (!card) return;

  var closeButton = card.querySelector('[data-nl-close]');
  var title = card.querySelector('[data-nl-title]');
  var email = card.querySelector('input[type="email"]');
  var success = card.querySelector('[data-nl-success]');
  var fields = card.querySelector('[data-nl-fields]');
  var formError = card.querySelector('[data-nl-error]');
  var returnField = card.querySelector('input[name="return_to"]');
  var KEY = 'mondo:nl';
  var JOURNEY_KEY = 'mondo:nl:journey';
  var SESSION_KEY = 'mondo:nl:presented';
  var MINIMUM_DELAY = 30000;
  var ACTIVE_DELAY = 90000;
  var CONSENT_COOLDOWN = 30000;
  var state = safeGet(localStorage, KEY);
  var opener = null;
  var shown = false;
  var automatic = false;
  var hideTimer = null;
  var observer = null;
  var autoTimers = [];
  var quietTimer = null;
  var minimumElapsed = false;
  var footerSeen = false;
  var engagementReady = false;
  var consentQuiet = false;
  var manualPending = false;

  function safeGet(storage, key) {
    try { return storage.getItem(key); } catch (e) { return null; }
  }

  function safeSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (e) {}
  }

  function remember(value) {
    state = value;
    safeSet(localStorage, KEY, value);
  }

  function readJourney() {
    var raw = safeGet(localStorage, JOURNEY_KEY);
    if (!raw) return { pageViews: 0 };
    try {
      var parsed = JSON.parse(raw);
      if (typeof parsed.pageViews === 'number') return parsed;
    } catch (e) {}
    return { pageViews: 0 };
  }

  function createActiveTimer(delay, callback) {
    var remaining = delay;
    var startedAt = 0;
    var timer = null;
    var complete = false;

    function cleanup() {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    }

    function finish() {
      timer = null;
      complete = true;
      cleanup();
      callback();
    }

    function start() {
      if (complete || timer !== null || document.visibilityState === 'hidden') return;
      startedAt = Date.now();
      timer = setTimeout(finish, remaining);
    }

    function pause() {
      if (timer === null) return;
      remaining = Math.max(0, remaining - (Date.now() - startedAt));
      clearTimeout(timer);
      timer = null;
    }

    function onVisibilityChange() {
      if (document.visibilityState === 'hidden') pause();
      else start();
    }

    document.addEventListener('visibilitychange', onVisibilityChange);
    start();

    return {
      cancel: function () {
        if (timer !== null) clearTimeout(timer);
        timer = null;
        complete = true;
        cleanup();
      }
    };
  }

  function consentVisible() {
    var consent = document.querySelector('[data-consent]');
    return consent && !consent.hidden;
  }

  function focusInvitation(target) {
    var focusTarget = target || email || title;
    if (focusTarget && focusTarget.focus) focusTarget.focus();
  }

  function show(focusTarget, isAutomatic) {
    if (hideTimer !== null) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    card.hidden = false;
    shown = true;
    automatic = !!isAutomatic;
    if (automatic) safeSet(sessionStorage, SESSION_KEY, 'yes');
    requestAnimationFrame(function () {
      card.classList.add('is-in');
      if (focusTarget) focusInvitation(focusTarget === true ? null : focusTarget);
    });
  }

  function hide(rememberDismissal) {
    if (rememberDismissal && state !== 'done') remember('dismissed');
    card.classList.remove('is-in');
    shown = false;
    automatic = false;
    hideTimer = setTimeout(function () {
      card.hidden = true;
      hideTimer = null;
      if (opener && opener.focus) opener.focus();
      opener = null;
    }, 320);
  }

  function stopAutomaticInvitation() {
    for (var i = 0; i < autoTimers.length; i += 1) autoTimers[i].cancel();
    autoTimers = [];
    if (observer) observer.disconnect();
    observer = null;
  }

  function attemptAutomaticInvitation() {
    if (!engagementReady || shown || consentQuiet) return;
    if (state === 'dismissed' || state === 'done') return;
    if (safeGet(sessionStorage, SESSION_KEY) === 'yes') return;
    if (consentVisible()) return;
    show(false, true);
    stopAutomaticInvitation();
  }

  function beginConsentQuietPeriod() {
    consentQuiet = true;
    if (quietTimer) quietTimer.cancel();
    quietTimer = createActiveTimer(CONSENT_COOLDOWN, function () {
      consentQuiet = false;
      quietTimer = null;
      if (manualPending) {
        manualPending = false;
        show(true, false);
        return;
      }
      attemptAutomaticInvitation();
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () { hide(true); });
  }

  card.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hide(true);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest
      ? event.target.closest('[data-nl-summon]')
      : null;
    if (!trigger) return;
    event.preventDefault();
    opener = trigger;
    if (consentVisible()) {
      manualPending = true;
      return;
    }
    show(true, false);
  });

  document.addEventListener('mondo:consent-opened', function () {
    if (!shown) return;
    if (!automatic) manualPending = true;
    hide(false);
  });

  document.addEventListener('mondo:consent-closed', function () {
    beginConsentQuietPeriod();
  });

  /* Liquid cannot read the query string, so the server renders return_to as
     the bare path. Rebuild it with the live query string, params kept before
     the #letters fragment, so filtered or paginated pages return intact. */
  if (returnField) {
    var keptParams = location.search.slice(1).split('&').filter(function (pair) {
      return pair && pair.indexOf('customer_posted=') !== 0;
    });
    returnField.value = location.pathname
      + (keptParams.length ? '?' + keptParams.join('&') : '')
      + '#letters';
  }

  var posted = (location.search + location.hash).indexOf('customer_posted=true') !== -1;

  if (success && !success.hidden) {
    remember('done');
    show(success, false);
    return;
  }

  if (success && posted) {
    /* Shopify confirmed the signup but customer_posted landed inside the
       fragment, so Liquid never saw it. Surface the success truth here. */
    if (fields) fields.hidden = true;
    success.hidden = false;
    remember('done');
    show(success, false);
    return;
  }

  if (formError) {
    show(true, false);
    return;
  }

  var journey = readJourney();
  journey.pageViews += 1;
  journey.pageViews = Math.min(journey.pageViews, 2);
  safeSet(localStorage, JOURNEY_KEY, JSON.stringify(journey));

  if (state === 'dismissed' || state === 'done') return;
  if (journey.pageViews < 2) return;
  if (safeGet(sessionStorage, SESSION_KEY) === 'yes') return;

  autoTimers.push(createActiveTimer(MINIMUM_DELAY, function () {
    minimumElapsed = true;
    if (footerSeen) {
      engagementReady = true;
      attemptAutomaticInvitation();
    }
  }));

  autoTimers.push(createActiveTimer(ACTIVE_DELAY, function () {
    engagementReady = true;
    attemptAutomaticInvitation();
  }));

  var footer = document.querySelector('#footer');
  if (footer && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (!entries[i].isIntersecting) continue;
        footerSeen = true;
        if (minimumElapsed) {
          engagementReady = true;
          attemptAutomaticInvitation();
        }
        observer.disconnect();
        break;
      }
    }, { threshold: 0.2 });
    observer.observe(footer);
  }
})();
